import { connect } from 'react-redux'
import TripsDashboard from '../../components/trips/TripsDashboard'
import * as actions from '../../state/actions/trips'
import * as riderActions from '../../state/actions/riders'
import { showOrgServiceArea, actionCreators as mapsActionCreators } from '../../state/actions/google_map'
import { getGoinzones } from '../../state/actions/goinzones'
import { IStoreState, ITripFilters, IRiderTrip, IPagination, IRiderFilters } from '../../types'
import history from 'src/history'
import moment from 'moment'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {
    orgId: state.organizations.currentOrgId,
    isFetching: state.trips.isFetching,
    zones: state.goinzones.items,
    trips: state.trips.items,
    riders: state.riders.items,
    tripFilters: state.trips.filters
  }
}

export function mapDispatchToProps(dispatch: any, ownProps: any) {
  return {
    showOrgServiceArea: () => dispatch(showOrgServiceArea()),
    getRiderPersonalInfo: (riderId: string): any => {
      return dispatch(riderActions.getRiderPersonalInfo(riderId))
    },
    fetchRiders: () => {
      return dispatch(riderActions.getMany({ isArchived: true }))
    },
    fetchTrips: (filters: ITripFilters, pagination?: IPagination) => {
      const combinedFilters = { ...filters, ...pagination }
      if (!filters.orgId) {
        return
      }

      return dispatch(actions.getManyTrips(combinedFilters))
    },
    filterTripsByZone: (payload: ITripFilters) => {
      if (!payload.orgId && payload.zoneId) {
        return
      }

      return dispatch(actions.filterByZone(payload))
    },

    updateTripFilters: (filters: ITripFilters) => {
      return dispatch(actions.actionCreators.updateTripFilters(filters))
    },

    getGoinzones: (orgId: string) => {
      return dispatch(getGoinzones(orgId))
    },

    cloneTrip: async (trip: IRiderTrip) => {
      let destinations
      try {
        const fetchedTrip = await dispatch(actions.getTripById(trip.id))
        destinations = fetchedTrip.destinations
      } catch (e) {
        destinations = []
        console.error('Failed to fetch trip details: ', e)
      }

      const tripClone = { ...trip }
      const pickup = {
        lat: tripClone.pickupLocation.latitude,
        lng: tripClone.pickupLocation.longitude
      }
      const dropoff = {
        lat: tripClone.dropoffLocation.latitude,
        lng: tripClone.dropoffLocation.longitude
      }
      const { routePolyline } = trip
      tripClone.product = { id: '', name: '', pricingId: '' }
      if (tripClone.rider) {
        tripClone.rider.birthDate = trip.rider ? trip.rider.birthDate : ''
      }
      tripClone.scheduledPickupTime = moment().toISOString()
      tripClone.scheduledDropoffTime = undefined
      tripClone.confirmationNumber = undefined
      tripClone.providerOneNumber = undefined
      tripClone.destinations = destinations

      await Promise.all([
        dispatch(actions.actionCreators.cloneTrip(tripClone)),
        dispatch(mapsActionCreators.setOrigin(pickup)),
        dispatch(mapsActionCreators.setDestination(dropoff)),
        dispatch(mapsActionCreators.replaceMarkers('origin', [{ type: 'origin', lat: pickup.lat, lng: pickup.lng }])),
        dispatch(
          mapsActionCreators.replaceMarkers('destination', [
            { type: 'destination', lat: dropoff.lat, lng: dropoff.lng }
          ])
        ),
        dispatch(
          actions.actionCreators.setTripPassengerDetails({
            tripRequestRiders: tripClone.tripsGroupRides || [],
            disabilityApproved: false,
            attendant: false
          })
        ),
        dispatch(
          actions.actionCreators.updateRiderCount(
            tripClone.tripsGroupRides!.reduce((partial, c) => {
              return partial + c.totalRider
            }, 0) || 1
          )
        )
      ])
      if (routePolyline) {
        dispatch(mapsActionCreators.setPolyline(routePolyline))
      }

      const riderId = trip.rider ? trip.rider.riderId : ''

      history.push(`/trips/create/${riderId}`)
    },
    onGroupScheduledTrips: async (param: ITripFilters) => {
      return dispatch(actions.groupRideRequestedScheduledTrips(param))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TripsDashboard)



// WEBPACK FOOTER //
// ./src/containers/trips/TripsDashboard.ts